module.exports = __webpack_public_path__ + "static/media/calculator.ddc2a360.svg";